import isEqual from "lodash/isEqual";

export const updateSelectedVariantOption = (variant_id, option_id) => {
	return {
		type: "UPDATE_SELECTED_VARIANT_OPTIONS",
		variant_id,
		option_id
	};
};

export const updateSelectedVariant = variant => {
	return {
		type: "UPDATE_SELECTED_VARIANT",
		variant
	};
};

export const unloadSelectedVariants = () => {
	return {
		type: "VARIANT_UNLOAD"
	};
};

export const setSelectedVariant = (variant_id, option_id, product) => {
	// console.log(variant_id, option_id, product);
	// console.log(product)
	// console.log(option_id);

	return (dispatch, getState) => {
		dispatch(updateSelectedVariantOption(variant_id, option_id));

		const variantsSelected = getState().productVariant.variant_options;
		const variantsSelectedIds = variantsSelected.map(item => item.option_id);

		// console.log(variantsSelectedIds);

		// Loop over product variants.  These contain an array of option ids that compose each variant.
		for (let itemId in product.variant_skus) {
			const variantItem = product.variant_skus[itemId];

			// console.log(variantItem);

			// Is the variant-option part of one of the product's variants?
			if (isEqual(variantItem.ids, variantsSelectedIds)) {
				// console.log(variantItem.ids + " is equal");
				dispatch(updateSelectedVariant(variantItem));
			}
		}
	};
};



// WEBPACK FOOTER //
// ./src/store/actions/productVariant.js